import React from "react";
import HeroSection from "./HeroSection/HeroSection";
import AboutSection from "./AboutSection/AboutSection";
import WhyCertification from "./WhyCertification/WhyCertification";
import FollowConnect from "../FollowConnect/FollowConnect";
import AmppCertificationSection from "./AmppCertificationSection/AmppCertificationSection";
import LandingCourse from "./LandingCourse/LandingCourse";
import EcaServicesLanding from "./EcaServicesLanding/EcaServicesLanding";

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <LandingCourse />
      <AmppCertificationSection />
      <WhyCertification />
      <EcaServicesLanding />
      <FollowConnect />
    </>
  );
};

export default Home;
